<script>
export default {
  name: 'ButtonDefault',
  props: {
    buttonText: {
      type: String,
      required: true,
      default: 'default',
    },
    isActive: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
};
</script>

<template>
  <button :class="[{ 'button-default--active': isActive }, 'button-default']" v-html="buttonText"></button>
</template>
